import { defineAbility } from '@casl/ability';
import { useEffect, useState } from 'react';
import { unpackRules } from '@casl/ability/extra';
import { useAuth0 } from '@auth0/auth0-react';
import { useGetUserAbilitiesQuery } from '@/__generated__/graphql';
import { Abilities } from '@/types';

const useAbility = () => {
  const [ability, setAbility] = useState(defineAbility(() => {}));
  const [loading, setLoading] = useState(true);
  const { data: userAbilities } = useGetUserAbilitiesQuery({
    fetchPolicy: 'cache-first',
  });
  const { user } = useAuth0();

  useEffect(() => {
    const fetchData = async () => {
      const data = userAbilities?.getUserAbilities;
      if (data) {
        const unpackedRules: Abilities = unpackRules(JSON.parse(data));
        if (user) {
          const permissions = user['http://abyssfabric.co/user/permissions'] as Array<string>;
          permissions?.forEach((permission) => {
            const [action, subject] = permission.split(':');
            unpackedRules.push({ action: [action], subject: [subject] });
          });
        }

        setAbility(defineAbility(() => {}).update(unpackedRules));
        setLoading(false);
      }
    };

    fetchData();
  }, [userAbilities?.getUserAbilities, user]);

  return { ability, loading };
};

export default useAbility;
